import React, { useState } from "react";
import Question from "./Single/Question";
import ToggleAnswersButton from "../../Elements/ToggleAnswersButton";

interface QuestionsProps {
  phase: {
    questions: any[];
  };
}

const Questions: React.FC<QuestionsProps> = ({ phase }) => {
  const [opens, setOpens] = useState<number[]>([]);
  const [openCommentQuestionId, setOpenCommentQuestionId] = useState<number | null>(null);

  const allOpen = (): boolean => {
    if (!phase) return false;
    return phase.questions.every(q => opens.includes(q.values[0].id));
  };

  const toggleAll = () => {
    if (allOpen()) {
      setOpens([]);
    } else {
      setOpens(phase.questions.map(q => q.values[0].id));
    }
  };

  const toggleOpen = (id: number) => {
    setOpens(prev =>
      prev.includes(id) ? prev.filter(o => o !== id) : [...prev, id]
    );
  };

  const toggleCommentSection = (questionId: number) => {
    setOpenCommentQuestionId((prev) => (prev === questionId ? null : questionId));
  };

  if (!phase) return null;

  return (
    <>
      <ToggleAnswersButton isOpen={allOpen()} onToggle={toggleAll} className="mb-4" />
      <div>
        {phase.questions.map((q, index) => (
          <Question
            key={index}
            question={q}
            index={index}
            opens={opens}
            toggleOpen={toggleOpen}
            commentsOpen={openCommentQuestionId === q.values[0].id}
            onToggleComments={() => toggleCommentSection(q.values[0].id)}
          />
        ))}
      </div>
    </>
  );
};

export default Questions;
